<template>
  <div class="wrapper">
    <div class="content-wrapper">
      <HeaderRegistered :return-path="returnPath" :sub-title="caseTitle" />
      <main class="main">
        <div class="dashboard-section">
          <CaseAssignList />
        </div>
      </main>
    </div>
  </div>
</template>

<script>

import HeaderRegistered from '../../layout/HeaderRegistered';
import CaseAssignList from './CaseAssignList';
import {computed} from 'vue';

export default {
  name: 'CaseAssign',
  components: {
    HeaderRegistered,
    CaseAssignList,
  },
  data() {
    return {
      caseTitle: '',
      returnPath: true,
    };
  },
  computed: {
    providedCaseName() {
      return this.caseTitle;
    }
  },
  provide() {
    return {
      caseName: computed(() => this.providedCaseName),
    };
  },
  mounted() {
    this.caseTitle = localStorage.getItem('title');
  },
};
</script>

<style scoped>

</style>